import React, { useEffect, useState } from "react"
import EventCalendarGroup from "./EventCalendarGroup"
import EventCalendarGroupList from "./eventCalendarGroupList"
import SpecificEvents from "./SpecificEvents"

const ManageEventsTab = ({ tabIsActive }) => {
  const TAB_CONTENT = {
    CALENDAR_LIST: 1,
    EVENT_CALENDAR: 2,
    SPECIFIC_EVENT: 3,
  }
  const [activeContent, setActiveContent] = useState(TAB_CONTENT.CALENDAR_LIST)

  useEffect(() => {
    setActiveContent(TAB_CONTENT.CALENDAR_LIST)
  }, [tabIsActive])

  return (
    <React.Fragment>
      {activeContent === TAB_CONTENT.CALENDAR_LIST && (
        <EventCalendarGroupList
          handleOpenEventCalendar={() =>
            setActiveContent(TAB_CONTENT.EVENT_CALENDAR)
          }
          handleOpenSpecificEvent={() =>
            setActiveContent(TAB_CONTENT.SPECIFIC_EVENT)
          }
        />
      )}
      {activeContent === TAB_CONTENT.EVENT_CALENDAR && (
        <EventCalendarGroup
          handleBack={() => setActiveContent(TAB_CONTENT.CALENDAR_LIST)}
        />
      )}
      {activeContent === TAB_CONTENT.SPECIFIC_EVENT && (
        <SpecificEvents
          handleBack={() => setActiveContent(TAB_CONTENT.CALENDAR_LIST)}
        />
      )}
    </React.Fragment>
  )
}

export default ManageEventsTab
